// @ts-nocheck
import React, { Component } from 'react';
import styles from './css/Search.module.css'
import SearchTopBar from './components/SearchTopBar'
import SearchResults from './components/SearchResults'
import SearchLanding from '../../globalcomponents/SearchLanding'
import Loading from './../../globalcomponents/Loading'
import apiFetch from './../../api/apiFetch'
import authService from '../../api/api-authorization/AuthorizeService'
import { withRouter } from '../../utility/withRouter'

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            spinning: false,
            ready: false,
            authenticated: false
        };
    }

    search(state) {
        this.startSearch()
        let temp = {}
        temp.state = Object.assign(state.search, state.filter)
        temp.user = this.props.user
        temp.state.COUNTRY_CODE = temp.state.COUNTRY_CODE;

        apiFetch(`/api/v2/search/exus`, temp).then((data) => {

            this.setState({ data: data, loaded: true, spinning: false });
        })
    }

    startSearch() {
        this.setState({ spinning: true });
    }

    showDetails(i) {
        this.setState({ Details: true, DetailsIndex: i })
    }

    showResults() {
        this.setState({ Details: false })
    }

    clearResults() {
        this.setState({ loaded: false })
    }

    saveState() {
        this.setState({ state: this.state })
    }

    UNSAFE_componentWillMount() {
        const locState = this.props.history.location.state;
        if (locState != null && locState.from) {
            if (locState.from.includes(this.props.match.path + '/details')) {
                this.setState(this.props.searchState)
            }
        }
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();

        const locState = this.props.history.location.state;
        if (locState != null && locState.from) {
            if (locState.from.includes(this.props.match.path + '/details')) {
                this.setState({ reload: true })
            }
        }
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
        const state = this.state;
        setTimeout(() => this.props.saveState(state), 0);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.path !== this.props.match.path) {
            this.setState({
                data: null,
                loaded: false,
                spinning: false
            })
        }
    }

    addTo(index, i, added, addSpend) {
        let json = {}
        if (added) {
            json.REQUEST_TYPE = "Remove from - Spend";
        }
        else {

            json.REQUEST_TYPE = "Add to - Spend";
        }
        json.PROF_ID = this.state.data[index].PROF_ID


        json.REQUESTOR_ID = this.props.user.email
        json.REQUESTOR_NAME = this.props.user.userName
        json.REQUESTOR_TEAM = this.props.user.team
        json.REQUESTOR_TERR = this.props.user.terr
        json.EMP_TYPE = this.props.user.role

        apiFetch('/api/v2/global/change-request', json).then((data) => {
            if (addSpend) {
                let json = {}
                json.REQUEST_TYPE = "Add to - Spend";
                json.PROF_ID = this.state.data[index].PROF_ID

                json.REQUESTOR_ID = this.props.user.email
                json.REQUESTOR_NAME = this.props.user.userName
                json.REQUESTOR_TEAM = this.props.user.team
                json.REQUESTOR_TERR = this.props.user.terr
                apiFetch('/api/v2/global/change-request', json)
            }
        })
    }


    render() {
        let view = ""
        if (this.state.spinning) {
            view = <Loading />
        }
        else if (this.state.loaded) {
            view = <SearchResults type={this.props.match.path} addTo={this.addTo.bind(this)} saveState={this.props.saveState} searchState={this.props.searchState} user={this.props.user} role={this.props.user.role} data={this.state.data} showDetails={this.showDetails.bind(this)} />
        }
        else {
            view = <SearchLanding type={this.props.match.path} />
        }
        return (
            <div className={styles.HCP_Search}>
                <SearchTopBar type={this.props.match.path} clearResults={this.clearResults.bind(this)} search={this.search.bind(this)} startSearch={this.startSearch.bind(this)} user={this.props.user} />
                {view}
            </div>
        );
    }

    async populateAuthenticationState() {
        const authenticated = await authService.isAuthenticated();
        this.setState({ ready: true, authenticated });
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }
}

export default withRouter(Search);
